import React, { useEffect, useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";
import {
  Box,
  CircularProgress,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Toolbar,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { BiLogoGmail } from 'react-icons/bi';
import { PiMicrosoftOutlookLogoFill } from "react-icons/pi";
import { SiZoho } from "react-icons/si";
import OutboxIcon from '@mui/icons-material/Outbox';
import SaveIcon from '@mui/icons-material/Save';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import ArchiveIcon from '@mui/icons-material/Archive';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../../user-redux/selector";
import { myCandidatesSelector } from "../../redux/selector";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step7 from "./Step7";
import StepReject from "./StepReject";
import SendCandidateToVendorEmail from "./emailTemplates/SendCandidateToVendorEmail";
import { EditRounded, EmailRounded, KeyboardArrowDown } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
  getSubmissionResumeDetails,
  selectedResume,
  sendProfileToVendor,
  getCandidateSubmissionStatusAction,
  getcandidateSubmissionsAction,
} from "../../redux/action";
import axios from "axios";
import Key from "../../../../clientVariables.json";
import { loginRequest } from "../../../../helpers/msalConfig";
import { Client } from "@microsoft/microsoft-graph-client";
import { useMsal } from "@azure/msal-react";
import { useGoogleLogin } from "@react-oauth/google";
import { useRef } from "react";

// Configuration
const totalSteps = 9;
const paperStyles = {
  borderRadius: "8px",
  overflow: "hidden",
  height: "calc(100vh - 160px)",
};

export default function SubmissionFlow() {

  const { instance, accounts } = useMsal();
  const [outlookToken, setOutlookToken] = useState(null);
  const [gmailAccessToken, setGmailAccessToken] = useState(null);
  const resumeSelectionHandler = {};
  const sharedData = {};
  const removeResumeFileHandlerStep2 = {};
  const selectedResumeDataSendToVendor = {};
  const dispatch = useDispatch();
  const [finalizedRound, setFinalizedRound] = useState(null);
  const prevBenchStatusRef = useRef(null);
  // When user clicks an earlier completed step (e.g. edit rate), don't yank them
  // back until status or submission changes.
  const userNavigatedBackRef = useRef(false);
  const [zohoEmail, setZohoEmail] = useState(
    () => sessionStorage.getItem("zoho_email") || null
  );
  const {
    candidateDetails,
    selectedSubmission,
    submissionSelectedResume,
    candidateSubmissions,
    submissionStatus
  } = useSelector(myCandidatesSelector);
  // Only trust submissionStatus when it belongs to the currently selected submission.
  // Stale status from a previous job caused left list vs right stepper mismatch.
  const statusMatchesSelected =
    submissionStatus?.candidate_id != null &&
    submissionStatus?.job_id != null &&
    selectedSubmission?.candidate_id != null &&
    selectedSubmission?.job_id != null &&
    Number(submissionStatus.candidate_id) ===
      Number(selectedSubmission.candidate_id) &&
    Number(submissionStatus.job_id) === Number(selectedSubmission.job_id);
  const benchStatusId = statusMatchesSelected
    ? submissionStatus?.bench_status_id
    : null;
  const effectiveBenchStatusId =
    benchStatusId ?? selectedSubmission?.bench_status_id ?? null;
  const selectedCandidate = candidateDetails;
  // const { user } = useSelector(userSelector);

  const [activeStep, setActiveStep] = useState(0);
  const [sendProfileToVendorEmailPreview, setSendProfileToVendorEmailPreview] = useState(false);
  const [step3EmailData, setStep3EmailData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openSuccessToast, setOpenSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [primaryResumeId, setPrimaryResumeId] = useState("");
  const currentUser = useSelector((state) => state.userManagement.user);
  const [maxStepReached, setMaxStepReached] = useState(0);
  const [zohoLoginEmail, setZohoLoginEmail] = useState("");
  const [openZohoEmailDialog, setOpenZohoEmailDialog] = useState(false);
  const [zohoAccessToken, setZohoAccessTokenState] = useState(() => sessionStorage.getItem("zoho_token"));
  const [zohoAccountsServer, setZohoAccountsServerState] = useState(() => sessionStorage.getItem("zoho_accounts_server"));

  const [zohoPopup, setZohoPopup] = useState(null);
  const [zohoAuthStep, setZohoAuthStep] = useState("idle"); // "idle", "manual_logout", "authenticating"
  const [zohoAuthUrl, setZohoAuthUrl] = useState("");


  const handleZohoLogout = () => {
    const server = zohoAccountsServer || sessionStorage.getItem("zoho_accounts_server") || "https://accounts.zoho.com";
    const accountsPage = server.includes("zoho.in") ? "https://accounts.zoho.in" : "https://accounts.zoho.com";

    // Open Zoho accounts page so user can manually sign out
    window.open(accountsPage, "_blank");

    setZohoAccessToken(null);
    setZohoAccountsServer(null);
    setZohoEmail(null);
    sessionStorage.removeItem("zoho_token");
    sessionStorage.removeItem("zoho_accounts_server");
    sessionStorage.removeItem("zoho_email");
    sessionStorage.removeItem("zoho_login_email");
    localStorage.removeItem("zoho_login_email");
    handleClose();
    // Redirect directly for fresh login
    handleZohoLogin();
  };

  const setZohoAccessToken = (token) => {
    if (token) {
      sessionStorage.setItem("zoho_token", token);
    } else {
      sessionStorage.removeItem("zoho_token");
    }
    setZohoAccessTokenState(token);
  };

  const setZohoAccountsServer = (server) => {
    if (server) {
      sessionStorage.setItem("zoho_accounts_server", server);
    } else {
      sessionStorage.removeItem("zoho_accounts_server");
    }
    setZohoAccountsServerState(server);
  };

  useEffect(() => {
    const handleZohoSuccess = (e) => {
      const { email, token, accountsServer } = e.detail || {};
      //console.log("[SubmissionFlow] Received zoho_auth_success event:", email);
      if (email) setZohoEmail(email);
      if (token) setZohoAccessToken(token);
      if (accountsServer) setZohoAccountsServer(accountsServer);
    };

    window.addEventListener("zoho_auth_success", handleZohoSuccess);

    const token = localStorage.getItem("zoho_token");
    const server = localStorage.getItem("zoho_accounts_server");
    const email = localStorage.getItem("zoho_email"); // ── add this

    if (token) {
      setZohoAccessToken(token);
      setZohoAccountsServer(server);
      if (email) {
        setZohoEmail(email);
        sessionStorage.setItem("zoho_email", email);
        localStorage.removeItem("zoho_email"); // clean up after reading
      }
      localStorage.removeItem("zoho_token");
      localStorage.removeItem("zoho_accounts_server");
      showToast(`Zoho authenticated as ${email || "unknown"}`);
    }

    return () => {
      window.removeEventListener("zoho_auth_success", handleZohoSuccess);
    };
  }, []);
  // useEffect(() => {
  //   console.log("activeStep", activeStep)
  //   console.log("selectedSubmission", selectedSubmission.nStatusName)
  //   console.log("candidateSubmissions", candidateSubmissions)
  //   console.log("user", user)
  // }, [activeStep, candidateSubmissions, user])

  // Menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Define all steps in the workflow
  const steps = [
    { label: "Accept Job Manually - Resume File Selection", optional: true },
    { label: "Send Profile To Vendor", optional: false },
    { label: "Accept Profile Manually", optional: true },
    { label: "Rate Confirmation", optional: false },
    { label: "Schedule Interview", optional: false },
    { label: "Interview Round-I Result", optional: false },
    { label: "Interview Round-II Result", optional: false },
    { label: "Interview Result", optional: false },
    {
      label:
        selectedSubmission?.pStatusName === "Selected"
          ? "Selected"
          : "Rejected",
      optional: false,
    },
  ];

  // Menu handlers
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // useEffect(() => {
  //   console.log("submissionStatus", selectedSubmission)
  // }, [submissionStatus])

  useEffect(() => {
    if (!selectedSubmission?.candidate_id || !selectedSubmission?.job_id) return;

    dispatch(
      getCandidateSubmissionStatusAction(
        selectedSubmission.candidate_id,
        selectedSubmission.job_id
      )
    );

    if (selectedSubmission.bench_status_id < 4) {
      const interval = setInterval(() => {
        dispatch(
          getCandidateSubmissionStatusAction(
            selectedSubmission.candidate_id,
            selectedSubmission.job_id
          )
        );
      }, 10000);
      return () => clearInterval(interval);
    }


  }, [selectedSubmission?.candidate_id, selectedSubmission?.job_id, selectedSubmission?.bench_status_id]);


  const STATUS_STEP_MAP = {
    1: 0,
    2: 1,
    3: 2,
    5: 3,
    7: 4,
    8: 5,
    11: 6,
    12: 7,
    9: 8,
    10: 8,
    6: 8,
    4: 8,
  };

  // Reset step when candidate changes
  useEffect(() => {
    userNavigatedBackRef.current = false;
    prevBenchStatusRef.current = null;
    setActiveStep(0);
    setMaxStepReached(0);
  }, [candidateDetails?.candidate_id]);

  // Reset manual back-nav when switching submissions so status sync can re-align
  useEffect(() => {
    userNavigatedBackRef.current = false;
    prevBenchStatusRef.current = null;
  }, [selectedSubmission?.candidate_id, selectedSubmission?.job_id]);

  // Keep right-panel step aligned with left-side list status.
  // - Prefer status API when it matches this submission; else list item
  // - Ignore null (no jump to step 0 / flicker during refetch)
  // - Always sync to mapped step unless user clicked an earlier step to edit
  // - Status change clears back-nav and follows the new status
  useEffect(() => {
    const statusId = effectiveBenchStatusId;
    if (statusId == null) return;

    const step = STATUS_STEP_MAP[Number(statusId)];
    if (step === undefined) return;

    const statusKey = `${selectedSubmission?.candidate_id}_${selectedSubmission?.job_id}_${statusId}`;
    const statusChanged =
      prevBenchStatusRef.current != null &&
      prevBenchStatusRef.current !== statusKey;
    prevBenchStatusRef.current = statusKey;

    setMaxStepReached((prev) => Math.max(prev, step));

    if (statusChanged) {
      userNavigatedBackRef.current = false;
      setActiveStep(step);
      return;
    }

    if (userNavigatedBackRef.current) return;

    setActiveStep(step);
  }, [
    effectiveBenchStatusId,
    selectedSubmission?.candidate_id,
    selectedSubmission?.job_id,
  ]);


  // Fetch resume data
  useEffect(() => {
    const fetchData = async () => {
      if (submissionSelectedResume) {
        if (
          selectedSubmission?.resume_id &&
          selectedSubmission?.resume_id !== submissionSelectedResume?.resume_id
        ) {
          const resume_id = selectedSubmission?.resume_id;
          //dispatch(getSubmissionResumeDetails(resume_id));
        }
      } else {
        getPrimaryResumeDetails();
      }
    };
    fetchData();
  }, [selectedSubmission, submissionSelectedResume, dispatch]);

  // Get primary resume details
  const getPrimaryResumeDetails = async () => {
    try {
      if (selectedCandidate?.candidate_id) {
        const response = await axios.post(
          `${Key.domain}/candidate/get_primary_resume_details`,
          { candidate_id: selectedCandidate.candidate_id }
        );

        const resume = response.data.data[0];
        setPrimaryResumeId(resume?.id || resume?.resume_id);
        dispatch(selectedResume(resume));
      }
    } catch (error) {
      console.error("Error fetching primary resume details:", error);
      showToast("Failed to fetch resume details", "error");
    }
  };

  // Handle toast messages
  const showToast = (message, severity = "success") => {
    setToastMessage(message);
    setOpenSuccessToast(true);
    setTimeout(() => {
      setOpenSuccessToast(false);
    }, 3000);
  };

  const handleSuccessToastClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessToast(false);
  };

  // Microsoft Outlook Authentication
  useEffect(() => {
    const initializeOutlookAuth = () => {
      const activeAccount = instance.getActiveAccount();
      if (!activeAccount && accounts.length > 0) {
        instance.setActiveAccount(accounts[0]);
      }
    };

    initializeOutlookAuth();
  }, [instance, accounts]);

  const acquireOutlookToken = async () => {
    try {
      setIsSubmitting(true);

      // 1. Get active account or set one if available
      let account = instance.getActiveAccount();
      if (!account && accounts.length > 0) {
        account = accounts[0];
        instance.setActiveAccount(account);
      }

      if (!account) {
        // No signed-in user yet, do interactive login
        const loginResponse = await instance.loginPopup({
          ...loginRequest,
          prompt: "select_account"
        });
        account = loginResponse.account;
        instance.setActiveAccount(account);
      }

      if (!account) {
        throw new Error("No account available ");
      }

      // 2. Try silent token acquisition
      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account,
        loginHint: account.username // Helps MSAL match the session
      });

      setOutlookToken(tokenResponse.accessToken);
      return tokenResponse.accessToken;
    } catch (error) {
      console.error("Error acquiring Outlook token:", error);
      showToast("Outlook authentication failed", "error");
      setIsSubmitting(false);
      throw error;
    }
  };

  const gmailLogin = useGoogleLogin({
    scope: "https://www.googleapis.com/auth/gmail.send",
    onSuccess: (tokenResponse) => {
      setGmailAccessToken(tokenResponse.access_token);
      showToast("Gmail authenticated successfully");
    },
    onError: () => {
      showToast("Gmail authentication failed", "error");
    }
  });

  const handleZohoLogin = (loginHintEmail = "") => {
    const CLIENT_ID = "1000.4OII743C9WQ1SSD0B2WZXEUE38X1YK";
    const REDIRECT_URI = "http://bs.jobsnprofiles.com/zoho/callback";
    //const REDIRECT_URI = "http://localhost:5050/zoho/callback";

    if (loginHintEmail) {
      sessionStorage.setItem("zoho_login_email", loginHintEmail);
      localStorage.setItem("zoho_login_email", loginHintEmail);
    }

    const stateData = {
      candidateId: selectedSubmission?.candidate_id,
      jobId: selectedSubmission?.job_id
    };

    const encodedState = btoa(JSON.stringify(stateData));

    let authUrl = `https://accounts.zoho.com/oauth/v2/auth`
      + `?scope=ZohoMail.messages.CREATE,ZohoMail.accounts.READ,profile,AaaServer.profile.Read`
      + `&client_id=${CLIENT_ID}`
      + `&response_type=code`
      + `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`
      + `&state=${encodedState}`
      + `&access_type=offline`
      + `&prompt=login`;

    if (loginHintEmail) {
      authUrl += `&login_hint=${encodeURIComponent(loginHintEmail)}`;
    }

    if (step3EmailData) {
      sessionStorage.setItem("saved_step3_data", JSON.stringify(step3EmailData));
    }

    //console.log("[ZohoLogin] Redirecting current browser tab to Zoho OAuth flow:", authUrl);
    window.location.href = authUrl;
  };


  // Unified send email handler
  const handleSendEmail = async (provider, token = null, accountsServer = null) => {
    try {
      // Data for updating submission status
      const updatedData = {
        candidateid: selectedSubmission?.candidate_id,
        jobid: selectedSubmission?.job_id,
        userid: currentUser?.id,
        status: "3", // Send to vendor status
      };

      // Get selected resume ID
      const selectedResumeId =
        submissionSelectedResume?.resume_id ||
        selectedSubmission?.resume_id ||
        primaryResumeId;

      // Create email payload
      const emailPayload = {
        ...step3EmailData,
        custom_body: step3EmailData?.customMode ? 1 : 0,
        signature_html: step3EmailData?.selectedSignatureHtml || "",
        provider,
        accessToken: (provider === "gmail" || provider === "zoho") ? token : null,
        token: (provider === "outlook" || provider === "zoho") ? token : null,
        accountsServer
      };

      if (step3EmailData && step3EmailData.attachmentFile) {
        const file = step3EmailData.attachmentFile;
        // Read file as base64
        emailPayload.customFile = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64 = reader.result.split(',')[1];
            resolve({
              name: file.name,
              contentBytes: base64,
              contentType: file.type || "application/octet-stream"
            });
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      }

      // Dispatch action to send profile
      await dispatch(
        sendProfileToVendor(
          emailPayload,
          updatedData,
          currentUser?.id,
          selectedSubmission?.candidate_id,
          selectedSubmission?.job_id,
          selectedResumeId,
          (provider === "outlook" || provider === "zoho") ? token : null,
          provider,
          (provider === "gmail" || provider === "zoho") ? token : null
        )
      );
      await dispatch(
        getCandidateSubmissionStatusAction(
          selectedSubmission?.candidate_id,
          selectedSubmission?.job_id
        )
      );

      const providerName = provider === 'gmail' ? 'Gmail' : provider === 'outlook' ? 'Outlook' : 'Zoho';
      showToast(`Email sent successfully using ${providerName}`);

      return true;
    } catch (error) {
      console.error("Error sending email:", error);
      const providerName = provider === 'gmail' ? 'Gmail' : provider === 'outlook' ? 'Outlook' : 'Zoho';
      showToast(`Failed to send email using ${providerName}`, "error");

      // Auto-clear Zoho credentials on send failure to force re-auth
      if (provider === "zoho") {
        //console.log("[ZohoSendError] Clearing active Zoho session credentials to trigger re-auth next time.");
        setZohoEmail(null);
        setZohoAccessToken(null);
        sessionStorage.removeItem("zoho_email");
        sessionStorage.removeItem("zoho_token");
        sessionStorage.removeItem("zoho_accounts_server");
      }

      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  // Step is driven by bench_status_id (same source as left list) — do not
  // restore a saved step from localStorage; that caused left/right mismatch.

  const handleSubmit = async (provider) => {
    // Close dropdown
    handleClose();

    // console.log("[handleSubmit] Clicked provider:", provider);
    // console.log("[handleSubmit] zohoAccessToken state:", zohoAccessToken);
    // console.log("[handleSubmit] sessionStorage zoho_token:", sessionStorage.getItem("zoho_token"));

    try {
      if (!step3EmailData) {
        showToast("Please prepare the email content first", "error");
        return;
      }

      if (provider === 'outlook') {
        const token = await acquireOutlookToken();
        if (token) {
          await handleSendEmail('outlook', token);
        }
      } else if (provider === "gmail") {
        if (!gmailAccessToken) {
          gmailLogin(); // open Google popup
          return;
        }
        await handleSendEmail("gmail", gmailAccessToken);
      } else if (provider === "zoho") {
        if (!zohoEmail && !sessionStorage.getItem("zoho_email")) {
          handleZohoLogin();
          return;
        }
        const currentToken = sessionStorage.getItem("zoho_token") || zohoAccessToken;
        const currentServer = sessionStorage.getItem("zoho_accounts_server") || zohoAccountsServer;
        await handleSendEmail("zoho", currentToken, currentServer);
      }
    } catch (error) {
      console.error(`${provider} authentication error:`, error);
      if (provider === "zoho") {
        setZohoAccessToken(null);
        setZohoAccountsServer(null);
      }
      showToast(`${provider} authentication failed: ${error.message || 'Unknown error'}`, "error");
      setIsSubmitting(false);
    }
  };

  const sendViaLocalZohoApi = async () => {
    try {
      setIsSubmitting(true);
      const email = zohoEmail || sessionStorage.getItem("zoho_email");

      //console.log("[sendViaLocalZohoApi] Sending as zohoEmail:", email);

      const response = await axios.post("http://localhost:3000/mail/zoho/send", {
        zohoEmail: email,  // backend looks up token by this
        toEmail: step3EmailData?.toEmail || "",
        subject: step3EmailData?.subject || "",
        emailContent: step3EmailData?.emailBody || "",
        ccEmails: step3EmailData?.ccEmail || "",
        bccEmail: step3EmailData?.bccEmail || ""
      });

      if (response.data?.success === 1 || response.data?.message) {
        showToast("Email sent successfully via Zoho!");
        return true;
      } else {
        throw new Error(response.data?.error || "Unknown error");
      }
    } catch (error) {
      // If backend says needs re-auth, clear email and prompt again
      if (error.response?.data?.needsAuth) {
        setZohoEmail(null);
        sessionStorage.removeItem("zoho_email");
        showToast("Zoho session expired. Please re-authenticate.", "error");
      } else {
        showToast(`Failed: ${error.message}`, "error");
      }
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };


  useEffect(() => {
    if (gmailAccessToken && step3EmailData) {
      handleSendEmail("gmail", gmailAccessToken);
    }
  }, [gmailAccessToken]);
  useEffect(() => {
    //console.log("selectedSubmission", selectedSubmission)
    const key = selectedSubmission?.candidate_id && selectedSubmission?.job_id
      ? `submissionFinalizedRound_${selectedSubmission.candidate_id}_${selectedSubmission.job_id}`
      : null;
    if (key) {
      // console.log("round key", key)
      // console.log("round localStorage", localStorage)
      const round = localStorage.getItem(key);
      // console.log("round", round)
      setFinalizedRound(round ? Number(round) : null);
      //console.log("round--", finalizedRound)
    } else {
      setFinalizedRound(null);
    }
  }, [selectedSubmission?.candidate_id, selectedSubmission?.job_id]);

  // Create progress bars for steps
  const progressBars = Array.from({ length: totalSteps }, (_, index) => {
    let isRestricted = false;
    if (finalizedRound) {
      if (finalizedRound === 1 && (index === 6 || index === 7)) isRestricted = true;
      if (finalizedRound === 2 && index === 7) isRestricted = true;
    }
    const maxAllowedStep = finalizedRound
      ? Math.min(maxStepReached, 4 + finalizedRound)
      : maxStepReached;

    const isClickable = !isRestricted && index <= maxAllowedStep;
    return (
      <LinearProgress
        key={index}
        variant="determinate"
        value={index < activeStep ? 100 : index === activeStep ? 50 : 0}
        sx={{
          width: `${100 / totalSteps}%`,
          margin: "1.6px",
          height: "4px",
          borderRadius: "20px",
          cursor: isRestricted
            ? "not-allowed"
            : isClickable
              ? "pointer"
              : "default",
          opacity: isRestricted
            ? 0.5
            : isClickable
              ? 1
              : 0.5,
          backgroundColor:
            index === activeStep ? "rgb(167, 202, 237)" : "rgb(167, 202, 237)",
          "& .MuiLinearProgress-bar": {
            backgroundColor: index === activeStep ? "#1976d2" : "#26d826",
          },
          "&::after": {
            content: '""',
            position: "absolute",
            right: "-6px",
            top: "50%",
            transform: "translateY(-50%)",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "transparent transparent transparent green",
            ...(index === activeStep && {
              borderColor: "transparent transparent transparent green",
            }),
          },
        }}
        onClick={() => {
          const maxAllowedStep = finalizedRound
            ? Math.min(maxStepReached, 4 + finalizedRound)
            : maxStepReached;

          if (isRestricted) {
            userNavigatedBackRef.current = false;
            setActiveStep(4 + finalizedRound);
            return;
          }
          if (index < activeStep) {
            // Allow revisiting completed steps (e.g. edit rate) without status yank
            userNavigatedBackRef.current = true;
            setActiveStep(index);
            return;
          }
          if (index > activeStep && index <= maxAllowedStep) {
            userNavigatedBackRef.current = false;
            setActiveStep(index);
            return;
          }
        }}
      />
    );
  });
  const step3EmailDataHandler = (data) => {
    setStep3EmailData(data);
  };

  const handleFinalizeRound = (round) => {
    setFinalizedRound(round);
  };
  const renderActiveStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <Step2
            //handleNext={handleNext}
            resumeSelectionHandler={resumeSelectionHandler}
            selectedResumeDataSendToVendor={selectedResumeDataSendToVendor}
            removeResumeFileHandlerStep2={removeResumeFileHandlerStep2}
          />
        );
      case 1:
        return (
          <div>
            <Toolbar sx={{ maxHeight: "48px !important" }}>
              <Typography paragraph sx={{ m: 0, fontWeight: 600 }}>
                {sendProfileToVendorEmailPreview
                  ? "Email Review"
                  : "Edit Email"}
              </Typography>

              <Box sx={{ flexGrow: 1 }} />
              <Tooltip title="Email Review" arrow placement="top">
                <IconButton
                  sx={{
                    backgroundImage: sendProfileToVendorEmailPreview
                      ? "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)"
                      : null,
                    height: "30px",
                    width: "30px",
                    mr: "5px",
                    border: !sendProfileToVendorEmailPreview
                      ? "1px solid #ddd"
                      : "none",
                  }}
                >
                  <EmailRounded
                    sx={{
                      color: sendProfileToVendorEmailPreview ? "#fff" : null,
                      height: "18px",
                      width: "18px",
                    }}
                    onClick={() => setSendProfileToVendorEmailPreview(true)}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit Email" arrow placement="top">
                <IconButton
                  sx={{
                    backgroundImage: !sendProfileToVendorEmailPreview
                      ? "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)"
                      : null,
                    height: "30px",
                    width: "30px",
                    border: sendProfileToVendorEmailPreview
                      ? "1px solid #ddd"
                      : "none",
                  }}
                >
                  <EditRounded
                    sx={{
                      color: !sendProfileToVendorEmailPreview ? "#fff" : null,
                      height: "18px",
                      width: "18px",
                    }}
                    onClick={() => setSendProfileToVendorEmailPreview(false)}
                  />
                </IconButton>
              </Tooltip>
              <Button
                variant="contained"
                disableElevation
                size="small"
                sx={{
                  textTransform: "capitalize",
                  ml: "5px",
                  backgroundImage: ["Selected", "Rejected"].includes(selectedSubmission?.pStatusName) || effectiveBenchStatusId !== 2
                    ? "none"
                    : "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={handleClick}
                endIcon={<KeyboardArrowDown />}
                disabled={
                  ["Selected", "Rejected"].includes(selectedSubmission?.pStatusName) || effectiveBenchStatusId !== 2
                }
              >
                {isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Send Email"
                )}
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <MenuItem onClick={() => handleSubmit('outlook')}>
                  <ListItemIcon>
                    <PiMicrosoftOutlookLogoFill fontSize="large" />
                  </ListItemIcon>
                  <ListItemText>Microsoft Outlook</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleSubmit('gmail')}>
                  <ListItemIcon>
                    <BiLogoGmail fontSize="large" />
                  </ListItemIcon>
                  <ListItemText>Send via Gmail</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleSubmit('zoho')}>
                  <ListItemIcon>
                    <SiZoho size={24} color="#e25c5c" />
                  </ListItemIcon>
                  <ListItemText>
                    {zohoEmail || sessionStorage.getItem("zoho_email")
                      ? "Send via Zoho"
                      : "Authenticate Zoho"}
                  </ListItemText>
                </MenuItem>
              </Menu>
            </Toolbar>
            <Divider />

            {sendProfileToVendorEmailPreview ? (
              <SendCandidateToVendorEmail step3EmailData={step3EmailData} selectedCandidateData={selectedCandidate} />
            ) : (
              <Step3
                sharedData={sharedData}
                step3EmailDataHandler={step3EmailDataHandler}
              />
            )}
          </div>
        );
      case 2:
        return <Step4 />;
      case 3:
        return (
          <Step5
            onRateSaved={() => {
              // Leave rate edit and jump to the live status step (Schedule Interview at status 7)
              userNavigatedBackRef.current = false;
              const statusId = Number(
                effectiveBenchStatusId ?? selectedSubmission?.bench_status_id
              );
              // After first confirm, status may still be catching up — target Schedule (4) once rate is done
              const mapped =
                STATUS_STEP_MAP[statusId] ??
                (Number.isFinite(statusId) && statusId >= 7 ? 4 : 3);
              const nextStep = mapped <= 3 ? 4 : mapped;
              setMaxStepReached((prev) => Math.max(prev, nextStep));
              setActiveStep(nextStep);
            }}
          />
        );
      case 4:
        return <Step6 />;
      case 5:
        return <Step7 round={1} onFinalizeRound={handleFinalizeRound} />;
      case 6:
        return <Step7 round={2} onFinalizeRound={handleFinalizeRound} />;
      case 7:
        return <Step7 round={3} onFinalizeRound={handleFinalizeRound} />;
      case 8:
        return <StepReject />;
      default:
        return <div>Step not found</div>;
    }
  };

  return (
    <Paper key={selectedSubmission?.submission_id} elevation={2} sx={paperStyles}>
      {/* Outer container: column flex, full height, no overflow */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {(!selectedSubmission || Object.keys(selectedSubmission).length === 0) ? (
          <div style={{ width: "100%", textAlign: "center", marginTop: 40 }}>
            <Typography
              sx={{
                color: "#4D5562",
                fontSize: "18px",
                fontWeight: 800,
              }}
            >
              No Submissions found to continue. Send a job to candidate to start submission flow.
            </Typography>
          </div>
        ) : (
          <>
            {/* ── STICKY HEADER: step label + progress bars (never scrolls) ── */}
            <div
              style={{
                flexShrink: 0,
                padding: "10px 10px 6px 10px",
                backgroundColor: "#fff",
                zIndex: 1,
              }}
            >
              {/* Step label row */}
              <div
                style={{
                  display: "flex",
                  gap: 20,
                  alignItems: "center",
                  justifyContent: "start",
                  width: "100%",
                  marginBottom: 6,
                }}
              >
                <Typography
                  variant="caption"
                  component="div"
                  sx={{
                    m: 0,
                    WebkitTextStroke: "0.75px #101010",
                    textStroke: "0.75px #101010",
                    color: "#101010",
                    fontSize: "20px",
                    letterSpacing: "2px",
                    fontWeight: 900,
                  }}
                >
                  {`Step ${activeStep + 1}`}
                </Typography>
                <Typography
                  paragraph
                  sx={{ m: 0, fontSize: "18px", fontWeight: 800, color: "#4D5562" }}
                >
                  {steps[activeStep]?.label}
                </Typography>
              </div>

              {/* Progress bars */}
              <div style={{ width: "100%", display: "flex" }}>{progressBars}</div>
            </div>

            {/* ── SCROLLABLE CONTENT: only this section scrolls ── */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                overflowX: "hidden",
                padding: "0 10px 10px 10px",
                width: "100%",
              }}
            >
              {!submissionStatus || submissionStatus.loading ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', gap: 2 }}>
                  <CircularProgress size={40} />
                  <Typography variant="body2" color="textSecondary">
                    Synchronizing status...
                  </Typography>
                </Box>
              ) : (
                renderActiveStepContent()
              )}
            </div>
          </>
        )}





        {/* Toast notifications */}
        <Snackbar
          open={openSuccessToast}
          autoHideDuration={6000}
          onClose={handleSuccessToastClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            onClose={handleSuccessToastClose}
            severity={
              toastMessage === "Something went wrong" || toastMessage?.includes("failed") ? "error" : "success"
            }
          >
            {toastMessage}
          </MuiAlert>
        </Snackbar>
      </div>
    </Paper>
  );
}
